module.exports = __webpack_public_path__ + "media/images/happy_button-41f97e744e23060beb468ea21ed7aab8.svg";